"use client";
import {
  __spreadValues
} from "../../../chunk-MMUBH76A.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { CpslButton, CpslDivider, CpslIcon } from "@getpara/react-components";
import { useMemo } from "react";
import { useModalStore, useUserInfoStore } from "../../stores/index.js";
import { ModalStep } from "../../utils/steps.js";
import { Heading, StepContainer, InnerStepContainer } from "../common.js";
import { openPopup } from "../../utils/openPopup.js";
import styled from "styled-components";
import { AuthMethod } from "@getpara/web-sdk";
import { formatBiometricHints, KnownDevices, UserIdentifier } from "@getpara/react-common";
const BiometricLoginStep = () => {
  const refs = useModalStore((state) => state.refs);
  const supportedAuthMethods = useModalStore((state) => state.supportedAuthMethods);
  const passwordUrlForLogin = useModalStore((state) => state.passwordUrlForLogin);
  const webAuthURLForLogin = useModalStore((state) => state.webAuthURLForLogin);
  const setStep = useModalStore((state) => state.setStep);
  const biometricLocationHints = useModalStore((state) => state.biometricLocationHints);
  const authInfo = useUserInfoStore((state) => state.getAuthInfo());
  const passkeysSupported = useModalStore((state) => state.isPasskeySupported);
  const formattedHints = useMemo(() => formatBiometricHints(biometricLocationHints), [biometricLocationHints]);
  const handlePasskeyClick = () => {
    refs.popupWindow.current = openPopup({
      url: webAuthURLForLogin,
      target: "ParaPasskey",
      type: "LOGIN_PASSKEY",
      current: refs.popupWindow.current
    });
    setStep(ModalStep.AWAITING_BIOMETRIC_LOGIN);
  };
  const handlePasswordClick = () => {
    refs.popupWindow.current = openPopup({
      url: passwordUrlForLogin,
      target: "ParaPassword",
      type: "LOGIN_PASSWORD",
      current: refs.popupWindow.current
    });
    setStep(ModalStep.AWAITING_PASSWORD_LOGIN);
  };
  function shouldShowWelcomeBack() {
    return !(biometricLocationHints == null ? void 0 : biometricLocationHints.length) || passkeysSupported && formattedHints.isOnKnownDevice || (supportedAuthMethods == null ? void 0 : supportedAuthMethods.has) && supportedAuthMethods.has(AuthMethod.PASSWORD);
  }
  return /* @__PURE__ */ jsxs(StepContainer, { $wide: true, children: [
    /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
      shouldShowWelcomeBack() && /* @__PURE__ */ jsx(Heading, { variant: "headingS", weight: "bold", children: "Welcome back," }),
      /* @__PURE__ */ jsx(UserIdentifier, __spreadValues({}, authInfo))
    ] }),
    /* @__PURE__ */ jsxs(MainContainer, { children: [
      (supportedAuthMethods == null ? void 0 : supportedAuthMethods.has) && supportedAuthMethods.has(AuthMethod.PASSWORD) && passwordUrlForLogin && /* @__PURE__ */ jsx(PasswordOnly, { handlePasswordClick }),
      (supportedAuthMethods == null ? void 0 : supportedAuthMethods.has) && supportedAuthMethods.has(AuthMethod.PASSKEY) && webAuthURLForLogin && /* @__PURE__ */ jsx(
        BiometricOnly,
        {
          handlePasskeyClick,
          formattedHints,
          shortLoginLink: webAuthURLForLogin,
          passkeysSupported,
          biometricLocationHints
        }
      )
    ] })
  ] });
};
const PasswordOnly = ({ handlePasswordClick }) => {
  return /* @__PURE__ */ jsx(CpslButton, { fullWidth: true, onClick: handlePasswordClick, children: "Login" });
};
const BiometricOnly = ({
  handlePasskeyClick,
  formattedHints,
  shortLoginLink,
  passkeysSupported,
  biometricLocationHints = []
}) => {
  const [hasHints, isOnKnownDevice] = [biometricLocationHints.length > 0, formattedHints.isOnKnownDevice];
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    (hasHints && !isOnKnownDevice || !passkeysSupported) && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(KnownDevices, { hints: formattedHints, link: shortLoginLink, showCurrentDevice: true }),
      /* @__PURE__ */ jsx(CpslDivider, { children: "or" })
    ] }),
    /* @__PURE__ */ jsx(CpslButton, { fullWidth: true, onClick: handlePasskeyClick, children: hasHints && !isOnKnownDevice || !passkeysSupported ? "Continue anyway" : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(CpslIcon, { slot: "start", icon: "key" }),
      "Login with passkey"
    ] }) })
  ] });
};
const MainContainer = styled(InnerStepContainer)`
  gap: 16px;
`;
export {
  BiometricLoginStep
};
